import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const jAndTApi = {
  getConfig: (request) => {
    const { pageid } = request
    return instance().get(`jt-express/${pageid}/config`)
  },
  putConfig: (request) => {
    const { pageid, data } = request
    return instance().put(`jt-express/${pageid}/config`, data)
  },
  postGenerateShop: (request) => {
    const { pageid } = request
    return instance().post(`jt-express/${pageid}/generate-shop`)
  },
  postCreateOrder: (request) => {
    const { pageid, data } = request
    return instance().post(`jt-express/${pageid}/verify-place-order`, data)
  },
  postPrintOrder: (request) => {
    const { pageid, data } = request
    return instance().post(`jt-express/${pageid}/print-mobile-label`, data)
  },
  postPostOrder: (request) => {
    const { pageid, data } = request
    return instance().post(`jt-express/${pageid}/place-order`, data)
  }
}

export default jAndTApi



// WEBPACK FOOTER //
// ./src/api/j-and-t.js